import { Schema } from "effect";
import { decodeUnknownOption } from "../../../packages/common/src/schema.ts";

/** Page sizes cap the scope of a single bulk operation. */
export const historyPageSizes = [10, 25, 50, 100] as const;
const pageSizeSchema = Schema.Literal(...historyPageSizes);
const pageSchema = Schema.Number.pipe(Schema.int(), Schema.between(1, 10000));

/** URL-owned history search and pagination, independent of transient selection. */
export function readHistoryView(params: URLSearchParams) {
  return {
    search: (params.get("q") ?? "").trim().slice(0, 200),
    page: decodeUnknownOption(pageSchema, Number(params.get("page"))) ?? 1,
    pageSize:
      decodeUnknownOption(pageSizeSchema, Number(params.get("pageSize"))) ?? 25,
  };
}

/** Update table controls without losing status, market, or device filters. */
export function writeHistoryView(
  params: URLSearchParams,
  view: ReturnType<typeof readHistoryView>,
) {
  const next = new URLSearchParams(params);
  for (const key of ["q", "page", "pageSize"]) next.delete(key);
  if (view.search.trim()) next.set("q", view.search.trim().slice(0, 200));
  if (view.page !== 1) next.set("page", String(view.page));
  if (view.pageSize !== 25) next.set("pageSize", String(view.pageSize));
  return next;
}
